// import Swiper from 'swiper';
// import {Navigation, Pagination, EffectFade, Autoplay, A11y} from 'swiper/modules';
//
// (function () {
//     // Get the body element
//     const body = document.body;
//     // Select all elements with the class 'swiper'
//     const swiperContainer = document.querySelectorAll(".swiper");
//     // Check if the current window name is 'neos-content-main', which indicates it's in the Neos backend
//     const inNeosBackend = window.name === 'neos-content-main';
//
//     function init(element) {
//         // Select the swiper container within the current element
//         const el = element.querySelector('.swiper-container');
//
//         // Initialize default Swiper settings
//         let slidesPerView = 1; // Default number of slides to show
//         let pagination = ".swiper-pagination"; // Default pagination element
//         let spaceBetween = 0; // Default space between slides
//         let centeredSlides = false; // Default for centering slides
//         let modules = [Navigation, Pagination, Autoplay]; // Default Swiper modules
//         let loop = false; // Default loop setting
//         let breakopints = false; // Default breakpoints
//         let effect = 'fade'; // Default slide effect
//         let autoplay = false;
//         let grabCursor =  false;
//         let allowTouchMove = true;
//         let speed = 300;
//
//         // Customize settings based on element class
//         if (element.classList.contains('reviews')) {
//             pagination = false;
//             slidesPerView = 1.1;
//             pagination = '.swiper-pagination';
//             spaceBetween = 32;
//             autoplay = false;
//             loop = false;
//             effect = false;
//             breakopints = {
//                 640: {
//                     slidesPerView: 1.1,
//                 },
//                 768: {
//                     slidesPerView: 2,
//                 },
//                 1024: {
//                     slidesPerView: 3,
//                     allowTouchMove: false
//                 },
//             }
//         } else if (element.classList.contains('cover')) {
//             modules = [Navigation, Pagination, Autoplay, EffectFade];
//             pagination = true;
//             slidesPerView = 1;
//             pagination = '.swiper-pagination';
//             spaceBetween = 0;
//             loop = false;
//             effect = 'fade';
//             speed = 2000;
//             autoplay = {
//                 delay: 10000,
//                 disableOnInteraction: false,
//             }
//             breakopints = {
//                 1024: {
//                     allowTouchMove: false
//                 },
//             }
//         } else if (element.classList.contains('image')) {
//             pagination = false;
//             slidesPerView = 1;
//             pagination = '.swiper-pagination';
//             spaceBetween = 32;
//             loop = false;
//             breakopints = {
//                 1024: {
//                     allowTouchMove: false
//                 },
//             }
//         } else if (element.classList.contains('products')) {
//             slidesPerView = 3.5;
//             modules = [Navigation, Pagination];
//             centeredSlides = false;
//             spaceBetween = 32;
//             loop = true;
//             breakopints = {
//                 0: {
//                     slidesPerView: 1,
//                 },
//                 640: {
//                     slidesPerView: 1,
//                 },
//                 768: {
//                     slidesPerView: 2,
//                 },
//                 1024: {
//                     slidesPerView: slidesPerView,
//                     allowTouchMove: false,
//                 },
//                 1600: {
//                     slidesPerView: 4,
//                     allowTouchMove: false,
//                 },
//                 2000: {
//                     slidesPerView: 5,
//                     allowTouchMove: false,
//                 },
//                 2500: {
//                     slidesPerView: 6,
//                     allowTouchMove: false,
//                 },
//             }
//         } else {
//             slidesPerView = 4.1;
//             modules = [Navigation, Pagination];
//             centeredSlides = true;
//             spaceBetween = 32;
//             loop = true;
//             breakopints = {
//                 640: {
//                     slidesPerView: 1,
//                     spaceBetween: 20,
//                 },
//                 768: {
//                     slidesPerView: 2,
//                 },
//                 1024: {
//                     slidesPerView: slidesPerView,
//                     allowTouchMove: false,
//                 },
//             }
//         }
//
//         // Initialize Swiper with the computed settings
//         const swiper = new Swiper(el, {
//             modules: modules,
//             slidesPerView: slidesPerView,
//             autoHeight: true, // Adjust height based on content
//             centeredSlides: centeredSlides,
//             speed: speed,
//             effect: effect,
//             fadeEffect: {
//                 crossFade: true
//             },
//             autoplay: autoplay,
//             spaceBetween: spaceBetween,
//             allowTouchMove: allowTouchMove,
//             loop: loop,
//             navigation: {
//                 nextEl: ".swiper-button-next",
//                 prevEl: ".swiper-button-prev",
//             },
//             grabCursor: grabCursor,
//             pagination: {
//                 el: pagination,
//                 clickable: true,
//             },
//             breakpoints: breakopints,
//             A11yOptions: {
//                 enabled: true
//             },
//             a11y: {
//                 slideLabelMessage: 'Slide {{index}} / {{slidesLength}}'
//             },
//             watchSlidesProgress: true,
//         });
//
//         // If in the Neos backend, set up mutation observers and event listeners
//         if (inNeosBackend) {
//             // Observe changes in the swiper wrapper (child slides)
//             const observeTarget = element.querySelector('.swiper-wrapper');
//             const observer = new MutationObserver((mutations) => {
//                 mutations.forEach((mutation) => {
//                     const addedNode = mutation.addedNodes[0];
//                     const removedNode = mutation.removedNodes[0];
//                     if (addedNode || removedNode) {
//                         console.log('Refreshing instance');
//                         swiper.update(); // Update Swiper to recognize changes
//                     }
//                     if (addedNode) {
//                         swiper.slideTo([...observeTarget.children].indexOf(addedNode));
//                     }
//                 });
//             });
//             observer.observe(observeTarget, { childList: true });
//
//             // Go to the slide if it gets selected in the node tree
//             document.addEventListener('Neos.NodeSelected', (event) => {
//                 const selectedElement = event.detail.element;
//                 if (selectedElement.classList.contains('swiper-slide')) {
//                     swiper.slideTo([...observeTarget.children].indexOf(selectedElement));
//                 }
//             });
//         }
//     }
//
//     // Initialize Swiper for each swiper container found
//     if (swiperContainer.length) {
//         swiperContainer.forEach(function (Slider) {
//             init(Slider);
//         });
//     }
//
//     // If in the Neos backend, reinitialize Swiper when a new node is created
//     if (body.classList.contains('neos-backend') && typeof document.addEventListener === 'function') {
//         document.addEventListener('Neos.NodeCreated', function (event) {
//             if (swiperContainer.length) {
//                 swiperContainer.forEach(function (Slider) {
//                     init(Slider);
//                 });
//             }
//         }, false);
//     }
// })();


import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay, A11y } from 'swiper/modules';

(function () {
    const body = document.body;
    const swiperInstances = new Map();
    const inNeosBackend = window.name === 'neos-content-main';

    function init(element) {
        const el = element.querySelector('.swiper-container') || element;

        // Check if slides are present before initializing
        const slides = el.querySelectorAll('.swiper-slide');
        if (slides.length === 0) {
            console.warn('No swiper slides found. Initialization aborted for:', element);
            return;
        }

        // Destroy existing Swiper instance for this element if it exists
        if (swiperInstances.has(el)) {
            swiperInstances.get(el).destroy(true, true);
            swiperInstances.delete(el);
        }

        // Initialize default Swiper settings
        let slidesPerView = 1;
        let pagination = ".swiper-pagination";
        let spaceBetween = 0;
        let centeredSlides = false;
        let modules = [Navigation, Pagination, Autoplay];
        let loop = false;
        let breakpoints = {};
        let slidesOffsetAfter = 0;
        let effect = 'fade';
        let autoplay = false;
        let grabCursor = false;
        let allowTouchMove = true;
        let speed = 300;

        // Customize settings based on element class
        if (element.classList.contains('reviews')) {
            pagination = '.swiper-pagination';
            slidesPerView = 1;
            spaceBetween = 32;
            autoplay = false;
            loop = false;
            effect = false;
            breakpoints = {
                640: { slidesPerView: 1.1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3, allowTouchMove: false }
            };
        } else if (element.classList.contains('cover')) {
            modules = [Navigation, Pagination, Autoplay, EffectFade];
            pagination = '.swiper-pagination';
            slidesPerView = 1;
            spaceBetween = 0;
            loop = false;
            effect = 'fade';
            speed = 2000;
            autoplay = { delay: 10000, disableOnInteraction: false };
            breakpoints = {
                1024: { allowTouchMove: false }
            };
        } else if (element.classList.contains('image')) {
            slidesPerView = 1;
            spaceBetween = 32;
            loop = false;
            breakpoints = {
                1024: { allowTouchMove: false }
            };
        } else if (element.classList.contains('products')) {
            slidesPerView = 3;
            modules = [Navigation, Pagination];
            spaceBetween = 32;
            loop = false;
            breakpoints = {
                0: { slidesPerView: 1, slidesOffsetAfter: 0 },
                640: { slidesPerView: 1, slidesOffsetAfter: 0 },
                768: { slidesPerView: 2, slidesOffsetAfter: 100 },
                1024: { slidesPerView: 3.5, allowTouchMove: false, slidesOffsetAfter: 150 },
                1600: { slidesPerView: 3.5, allowTouchMove: false, slidesOffsetAfter: 150 },
                2000: { slidesPerView: 4, allowTouchMove: false, slidesOffsetAfter: 100 },
                2500: { slidesPerView: 4.5, allowTouchMove: false, slidesOffsetAfter: 600 }
            };
        } else {
            slidesPerView = 4.1;
            modules = [Navigation, Pagination];
            centeredSlides = true;
            spaceBetween = 32;
            loop = true;
            breakpoints = {
                640: { slidesPerView: 1, spaceBetween: 20 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: slidesPerView, allowTouchMove: false }
            };
        }

        // Initialize Swiper
        const swiper = new Swiper(el, {
            modules: modules,
            slidesPerView: slidesPerView,
            autoHeight: true,
            centeredSlides: centeredSlides,
            speed: speed,
            effect: effect,
            fadeEffect: { crossFade: true },
            autoplay: autoplay,
            spaceBetween: spaceBetween,
            allowTouchMove: allowTouchMove,
            loop: loop,
            navigation: {
                nextEl: element.querySelector(".swiper-button-next"), // Scoped to specific slider
                prevEl: element.querySelector(".swiper-button-prev") // Scoped to specific slider
            },
            grabCursor: grabCursor,
            pagination: pagination ? { el: element.querySelector(pagination), clickable: true } : false,
            breakpoints: breakpoints,
            a11y: {
                enabled: true,
                slideLabelMessage: 'Slide {{index}} / {{slidesLength}}'
            },
            watchSlidesProgress: true
        });

        // Store the swiper instance
        swiperInstances.set(el, swiper);

        // Delay to ensure styles are correctly applied
        setTimeout(() => {
            swiper.updateSlides();
            swiper.updateAutoHeight();
            swiper.update();
        }, 100); // Small delay to allow DOM to settle

        // If in the Neos backend, add the Neos.NodeSelected event listener
        if (inNeosBackend) {
            const observeTarget = element.querySelector('.swiper-wrapper');

            // Go to the slide if it gets selected in the node tree
            document.addEventListener('Neos.NodeSelected', (event) => {
                const selectedElement = event.detail.element;
                if (selectedElement.classList.contains('swiper-slide')) {
                    swiper.slideTo([...observeTarget.children].indexOf(selectedElement));
                }
            });
        }
    }

    function initializeSwipers() {
        document.querySelectorAll(".swiper").forEach((Slider) => {
            // Only initialize if it hasn't been initialized yet
            const swiperContainer = Slider.querySelector('.swiper-container') || Slider;
            if (!swiperInstances.has(swiperContainer)) {
                init(Slider);
            }
        });
    }

    // Initialize all swipers on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', initializeSwipers);

    // Observe DOM changes to detect new sliders
    const observer = new MutationObserver(() => {
        setTimeout(() => {
            initializeSwipers(); // Delay to ensure new elements are fully added before initialization
        }, 100); // Small delay to ensure all new nodes are ready
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Handle Neos backend-specific reinitialization logic
    if (body.classList.contains('neos-backend')) {
        document.addEventListener('Neos.NodeCreated', () => {
            setTimeout(() => {
                initializeSwipers();
            }, 100); // Small delay to ensure new node is fully added before initialization
        });
    }
})();

